import { connect } from 'react-redux';
import * as actions from './flashMessage.actions';
import FlashMessage from './flashMessage';

function mapStateToProps(state){
  return {
    message: state.message
  };
}

export default connect(mapStateToProps, actions)(FlashMessage);
